import { css } from '@emotion/css'
import { spacing, breakpoint, mediaQueryHelper } from '@offerzen/pinata'

const styles = {
  card: css({
    display: 'block',
    marginBottom: spacing.medium,
    padding: spacing.medium,
  }),

  header: css({
    display: 'flex',
    alignItems: 'center',
    marginBottom: spacing.default,

    [mediaQueryHelper(breakpoint.phone)]: {
      justifyContent: 'center',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      justifyContent: 'flex-start',
    },
  }),

  icon: css({
    width: 56,
    height: 56,
    marginRight: spacing.default,
    flex: 'none',
  }),

  content: css({
    height: 100,
  }),
}

export default styles
